var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"visible":true,"title":"查看图片","footer":null,"width":800},on:{"cancel":_vm.handleCancel}},_vm._l((_vm.pictures),function(src,i){return _c('img',{key:i,staticStyle:{"width":"100%","margin-bottom":"8px"},attrs:{"src":src}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ddd985e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PreviewImage.vue
// module id = null
// module chunks = 